import { FC } from "react";

import { type StatusIconProps, initializeStatusIconProps } from "mds/utils/images";

export const PageListStatusIcon: FC<StatusIconProps> = (props) => {
  const { statusClassName, ...svgProps } = initializeStatusIconProps(props);
  return (
    <svg {...svgProps}>
      <path
        d="M11.318 5.97614V4.79547C11.318 4.38126 10.9822 4.04547 10.568 4.04547H2.88637C2.47215 4.04547 2.13637 4.38126 2.13637 4.79547V13.7496C2.13637 14.1638 2.47215 14.4996 2.88637 14.4996H6.79066C7.06666 14.4996 7.29042 14.7236 7.29066 14.9996C7.29066 15.2757 7.06681 15.4996 6.79066 15.4996H2.88637C1.91987 15.4996 1.13637 14.7161 1.13637 13.7496V4.79547C1.13637 3.82897 1.91987 3.04547 2.88637 3.04547H10.568C11.5345 3.04547 12.318 3.82897 12.318 4.79547V5.97614C12.3178 6.25211 12.094 6.47614 11.818 6.47614C11.5421 6.47604 11.3182 6.25205 11.318 5.97614Z"
        fill="currentColor"
      />
      <path
        d="M13.8638 6.69824V3.25C13.8638 2.28356 13.0802 1.5001 12.1138 1.5H3.54546C3.26931 1.5 3.04546 1.27614 3.04546 1C3.04546 0.723858 3.26931 0.5 3.54546 0.5H12.1138C13.6325 0.500096 14.8638 1.73128 14.8638 3.25V6.69824C14.8637 6.97421 14.6398 7.19815 14.3638 7.19824C14.0878 7.19824 13.864 6.97427 13.8638 6.69824Z"
        fill="currentColor"
      />
      <path
        d="M9.27264 6.22726C9.54879 6.22726 9.77264 6.45112 9.77264 6.72726C9.77264 7.00341 9.54879 7.22726 9.27264 7.22726H4.18182C3.90568 7.22726 3.68182 7.00341 3.68182 6.72726C3.68182 6.45112 3.90568 6.22726 4.18182 6.22726H9.27264Z"
        fill="currentColor"
      />
      <path
        d="M6.61737 8.77274C6.89351 8.77274 7.11737 8.99659 7.11737 9.27274C7.11737 9.54888 6.89351 9.77274 6.61737 9.77274H4.18182C3.90568 9.77274 3.68182 9.54888 3.68182 9.27274C3.68182 8.99659 3.90568 8.77274 4.18182 8.77274H6.61737Z"
        fill="currentColor"
      />
      <path
        d="M5.92401 11.3182C6.20015 11.3182 6.42401 11.542 6.42401 11.8182C6.42401 12.0943 6.20015 12.3182 5.92401 12.3182H4.18182C3.90568 12.3182 3.68182 12.0943 3.68182 11.8182C3.68182 11.542 3.90568 11.3182 4.18182 11.3182H5.92401Z"
        fill="currentColor"
      />
      <rect className={statusClassName} height="6" rx="3" stroke="none" width="6" x="9" y="9" />
    </svg>
  );
};
